import { render, staticRenderFns } from "./FileUploadItem.vue?vue&type=template&id=d4264e3a&scoped=true"
import script from "./FileUploadItem.vue?vue&type=script&lang=js"
export * from "./FileUploadItem.vue?vue&type=script&lang=js"
import style0 from "./FileUploadItem.vue?vue&type=style&index=0&id=d4264e3a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4264e3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4264e3a')) {
      api.createRecord('d4264e3a', component.options)
    } else {
      api.reload('d4264e3a', component.options)
    }
    module.hot.accept("./FileUploadItem.vue?vue&type=template&id=d4264e3a&scoped=true", function () {
      api.rerender('d4264e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/File/FileUploadItem.vue"
export default component.exports